<template>
  <div class="box">
    <navBar :tabIndex="99" :showLogo="true"></navBar>
    <div class="inlineBox">
      <div class="topBg"></div>
      <div class="topTbox">
        <img
          class="topTitl"
          src="https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo3/jp-t-l.png"
          alt=""
        />
        <div class="topTitle">纪录片案例展示</div>
        <img
          class="topTitr"
          src="https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo3/jp-t-r.png"
          alt=""
        />
      </div>
      <div class="videoBox">
        <video
          ref="video1"
          controls
          :src="videoUrl1"
          :poster="poster1"
          @ended="playEnd"
          :http-cache="false"
          t7-video-player-type="inline"
          webkit-playsinline="true"
          playsinline="true"
          x-webkit-airplay="true"
          x5-playsinline="showLine"
        ></video>
      </div>
      <!-- <div class="midTbox">
        <img
          class="topTitl"
          src="https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo3/jp-t-l.png"
          alt=""
        />
        <div class="topTitle">我们的优势</div>
        <img
          class="topTitr"
          src="https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo3/jp-t-r.png"
          alt=""
        />
      </div> -->
      <img
        class="midImg"
        src="https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo3/mid-bg-pc1.png"
        alt=""
      />
      <div class="botTbox">
        <img
          class="topTitl"
          src="https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo3/jp-t-l.png"
          alt=""
        />
        <div class="topTitle">我要拍摄</div>
        <img
          class="topTitr"
          src="https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo3/jp-t-r.png"
          alt=""
        />
      </div>
      <div class="sendInfoBox">
        <div class="sendIt">
          <div class="sendTit">
            <span style="color: #d5422c">*</span>
            <span class="nameBod">姓</span>名：
          </div>
          <div class="sendInp">
            <input type="text" v-model="sendName" placeholder="请输入姓名" />
          </div>
        </div>
        <div class="sendIt">
          <div class="sendTit">
            <span style="color: #d5422c">*</span>手机号：
          </div>
          <div class="sendInp">
            <input
              type="text"
              v-model="sendPhone"
              placeholder="请输入手机号码"
            />
          </div>
        </div>
        <div class="sendIt" style="display: block; text-align: left">
          <div class="sendFlex">
            <div class="sendTit" style="margin-right: 30px; margin-bottom: 0">
              拍摄类型<span style="color: #ac6d1b">(可多选)</span>
            </div>
            <div class="typeBox">
              <div
                class="typeItem"
                :class="{ active: item.check == true }"
                :style="{
                  'padding-left':
                    index == typeList.length - 1 ? $px2rem(`${30}px`) : '0',
                  'padding-right':
                    index == typeList.length - 1 ? $px2rem(`${30}px`) : '0',
                }"
                v-for="(item, index) in typeList"
                :key="index"
                @click="item.check = !item.check"
              >
                {{ item.name }}
                <img
                  class="checkIcon"
                  v-if="item.check == true"
                  src="https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo3/checkIcon-b.png"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div class="sendBtn" @click="toSend"></div>
        </div>
      </div>
    </div>
    <transition name="el-fade-in-linear">
      <div class="wrapper" v-show="showewm">
        <div class="ewmBox">
          <div class="ewmTop">
            <img
              class="ewmSuc"
              src="https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo3/jlpewmSucIcon.png"
              alt=""
            />
            <div class="ewmTit">提交成功</div>
            <img
              class="ewmClose"
              src="https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo3/jlpewm-close.png"
              alt=""
              @click="showewm = false"
            />
          </div>
          <div class="conter">工作人员会在两个工作日以内联系您~</div>
          <div class="botter">
            <div class="botIt">
              <span style="margin-right: 20px">添加客服</span>
              <span>立即获取报价</span>
            </div>
            <img class="botImg" :src="ewmImg" />
            <div class="botWxcode" @click="copyText">
              <div class="wx1">微信号:</div>
              <div class="wx1">{{ wxCode }}</div>
              <div class="wx2">复制</div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <tabBar></tabBar>
  </div>
</template>

<script>
import { getDictTypeMap, contactUs } from "@/api/request";
export default {
  components: {},
  data() {
    return {
      videoUrl1: "",
      poster1: "",
      sendName: "",
      sendPhone: "",
      typeList: [],
      showewm: false,
      ewmImg: "",
      wxCode: "",
    };
  },
  created() {
    this.getVideo();
    this.getEwm();
    this.getTypes();
  },
  mounted() {},
  methods: {
    playEnd() {
      this.videoUrl1 = this.videoUrl1 + "?timestamp=" + new Date().getTime();
    },
    getVideo() {
      getDictTypeMap("online_sacrifice_video").then((r) => {
        this.videoUrl1 = r.data.data.video1;
        this.poster1 = r.data.data.post1;
      });
    },
    getEwm() {
      getDictTypeMap("wx_service").then((r) => {
        this.ewmImg = r.data.data.wx_service_qrcode;
        this.wxCode = r.data.data.wx_service_code;
      });
    },
    getTypes() {
      getDictTypeMap("zxjs_screen_type").then((r) => {
        let originalObject = r.data.data;
        this.typeList = Object.keys(originalObject)
          .map((key) => {
            // 假设"1"表示check为true，其他值表示check为false
            const check = originalObject[key] === "1";
            return {
              name: key,
              check: check,
              num: originalObject[key],
            };
          })
          .sort((a, b) => {
            // 如果你想根据原始对象的值进行排序（从"1"到更大的数字），可以添加此排序逻辑
            // 但由于你的示例数组没有特定的排序要求，这里只是注释出排序逻辑
            // 注意：JavaScript中的对象键是无序的，所以原始的顺序可能无法保留
            let valueA = a.num;
            let valueB = b.num;
            return valueA - valueB; // 升序排序
            //return valueB - valueA; // 降序排序
            //return 0; // 不排序
          });
      });
    },
    toSend() {
      if (!this.sendName) {
        this.$message.error("请填写姓名！");
        return;
      }
      if (!this.sendPhone || this.sendPhone.length < 11) {
        this.$message.error("请填写正确的手机号！");
        return;
      }
      let arr = this.typeList
        .filter((item) => {
          return item.check == true;
        })
        .map((item) => {
          return item.num;
        });
      let data = {
        name: this.sendName,
        phone: this.sendPhone,
        screenType: arr.toString(),
        channelType: 3,
      };
      contactUs(data).then((res) => {
        if (res.data.code === 200) {
          this.sendName = "";
          this.sendPhone = "";
          this.showewm = true;
        } else {
          this.$message(res.data.msg);
        }
      });
    },
    copyText() {
      const input = document.createElement("input");
      input.value = this.wxCode; // 获取要复制的文本
      document.body.appendChild(input);
      input.select(); // 选中文本
      document.execCommand("copy"); // 执行复制操作
      document.body.removeChild(input); // 移除临时的输入框
      this.$message("复制成功！"); // 可选：给用户一个反馈
    },
  },
};
</script>
<style lang="scss" scoped>
.box {
  width: 100%;
  min-height: 100vh;
  background: #3b280f;
  position: relative;
  .inlineBox {
    width: 100%;
    min-height: 2323px;
  }
  .topBg {
    width: 100%;
    min-height: 2323px;
    background: url("https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo3/jlp-bg-pc.png")
      no-repeat;
    background-size: 100% 100%;
    position: absolute;
    top: 56px;
    left: 0;
    right: 0;
  }
  .topTbox {
    padding-top: 437px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }
  .topTitl {
    width: 183px;
    height: 4px;
    margin-right: 20px;
  }
  .topTitle {
    font-size: 30px;
    font-weight: 600;
    color: #ffffff;
    background: -webkit-linear-gradient(180deg, #e9d8ac 0%, #eacb7b 81.25%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    display: inline-block;
    filter: drop-shadow(2px 4px 6px #2b1903a1);
  }
  .topTitr {
    width: 183px;
    height: 4px;
    margin-left: 20px;
  }
  .videoBox {
    background: url("https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo3/videoBox-bg.png")
      no-repeat;
    background-size: 100% 100%;
    width: 925px;
    height: 560px;
    position: relative;
    margin: 0 auto;
    margin-top: 25px;
    video {
      width: 846px;
      height: 462px;
      object-fit: cover;
      margin-top: 33px;
    }
  }
  .midTbox {
    padding-top: 56px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }
  .midImg {
    width: 1178px;
    height: 309px;
    position: relative;
    margin-top: 56px;
  }
  .botTbox {
    padding-top: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }
  .sendInfoBox {
    background: url("https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo3/bot-bg-pc.png")
      no-repeat;
    background-size: 100% 100%;
    width: 1180px;
    height: 437px;
    margin: 0 auto;
    margin-top: 43px;
    box-sizing: border-box;
    padding: 67px 90px 0 90px;
    position: relative;
    .sendIt {
      display: flex;
      align-items: center;
      margin-bottom: 26px;
    }
    .sendFlex {
      display: flex;
      align-items: center;
      margin-bottom: 26px;
    }
    .sendTit {
      font-size: 26px;
      color: #3b280f;
      .nameBod {
        margin-right: 26px;
      }
    }
    .sendInp {
      width: 342px;
      height: 52px;
      background: #fffae5;
      border-radius: 41px;
      font-weight: 400;
      input {
        width: 342px;
        height: 52px;
        outline: none;
        border: none;
        background: transparent;
        font-size: 26px;
        padding-left: 24px;
      }
      ::-webkit-input-placeholder {
        /* Chrome, Opera, Safari */
        color: #eaba7b;
        font-weight: 400;
      }

      :-moz-placeholder {
        /* Firefox 18- */
        color: #eaba7b;
        opacity: 1; /* 修复老版本Firefox的不透明度问题 */
        font-weight: 400;
      }

      ::-moz-placeholder {
        /* Firefox 19+ */
        color: #eaba7b;
        opacity: 1; /* 修复Firefox的不透明度问题 */
        font-weight: 400;
      }

      :-ms-input-placeholder {
        /* Internet Explorer 10-11 */
        color: #eaba7b;
        font-weight: 400;
      }
    }
    .typeBox {
      display: flex;
      justify-content: space-between;
      .typeItem {
        min-width: 160px;
        width: max-content;
        height: 56px;
        line-height: 56px;
        border: 2px solid #eaba7b;
        border-radius: 50px;
        text-align: center;
        white-space: nowrap;
        display: flex;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        font-size: 24px;
        margin-right: 20px;
      }
      .checkIcon {
        width: 22px;
        height: 14px;
      }
      .active {
        background: linear-gradient(180deg, #ffe0b6 0%, #cc7c13 100%);
        color: #7c4116;
        font-size: 24px;
        font-weight: 600;
        border: none;
        box-sizing: unset;
      }
    }
    .sendBtn {
      width: 373px;
      height: 74px;
      background: url("https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo3/getPrice-bg-pc.png")
        no-repeat;
      background-size: 100% 100%;
      margin: 0 auto;
      margin-top: 34px;
    }
  }
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    //height: 100%;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.2);
    width: 100%;
    height: 100%;
    z-index: 999;
    .ewmBox {
      width: 630px;
      height: 727px;
      background: url("https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo3/jlp-ewm-bg.png")
        no-repeat;
      background-size: 100% 100%;
      .ewmTop {
        display: flex;
        align-items: center;
        justify-content: center;
        padding-top: 34px;
        position: relative;
      }
      .ewmSuc {
        width: 49px;
        height: 49px;
        border-radius: 50%;
        flex: none;
        margin-right: 14px;
      }
      .ewmTit {
        color: #57360f;
        font-size: 40px;
        font-weight: 600;
      }
      .ewmClose {
        width: 27px;
        height: 27px;
        position: absolute;
        right: 30px;
      }
      .conter {
        color: #ac6d1b;
        font-size: 32px;
        font-weight: 500;
        margin-top: 40px;
      }
      .botter {
        width: 570px;
        background: #fffaf2;
        border-radius: 14px;
        margin: 0 auto;
        margin-top: 37px;
        padding: 30px 0;
        box-sizing: border-box;
        .botIt {
          color: #ac6d1b;
          font-size: 30px;
          font-weight: 400;
        }
        .botImg {
          width: 245px;
          height: 245px;
          margin-top: 18px;
        }
        .botWxcode {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 19px;
          .wx1 {
            color: #ac6d1b;
            font-size: 28px;
            font-weight: 400;
          }
          .wx2 {
            color: #3f639a;
            font-size: 26px;
            font-weight: 400;
            text-decoration-line: underline;
            margin-left: 8px;
          }
        }
      }
    }
  }
}
</style>
